import {h, render, Component} from 'preact';
import {observer} from 'mobx-react';
import SharedFiltersStore from "./store/SharedFiltersStore";
import getSharedValue from '../libs/getSharedValue';

export default observer(
    class FilterItemBoolean extends Component {
        constructor(props) {
            super(props);
        }

        handleChange = e => {
            const { target } = e;
            SharedFiltersStore.saveFilterPropertyStatus(this.props.id, 'value', target.value);

            if (typeof (this.props.onChange) === 'function') {
                this.props.onChange(this.props.id, Boolean(parseInt(e.target.value)))
            }
        }

        render() {
            const props = this.props;
            const sharedValue = getSharedValue(props.sharedState, 'value');

            return (
                <fieldset class="catalogue__filter__group">
                    <legend class="catalogue__filter__group__title">
                        {props.title}
                    </legend>

                    <ul class="catalogue__filter__options">
                        <li class="catalogue__filter__options__item">
                            <label
                                class="catalogue__filter__options__label">
                                Да
                                <input
                                    name={props.id}
                                    type="radio"
                                    value="1"
                                    {...(props.sharedState ? { checked: sharedValue === "1" } : {})}
                                    onChange={this.handleChange}/>
                                <span
                                    class="radiobutton catalogue__filter__options__radiobutton">
                            </span>
                            </label>
                        </li>
                        <li class="catalogue__filter__options__item">
                            <label
                                class="catalogue__filter__options__label">
                                Нет
                                <input
                                    name={props.id}
                                    type="radio"
                                    value="0"
                                    {...(props.sharedState ? { checked: sharedValue === "0" } : {})}
                                    onChange={this.handleChange}/>
                                <span
                                    class="radiobutton catalogue__filter__options__radiobutton">
                            </span>
                            </label>
                        </li>
                    </ul>
                </fieldset>
            )
        }
    }
);